/* eslint-disable no-unused-vars */
import React from 'react';
import { BusinessPlanProps } from '../../../Types/types';
import RowGroups from '../ScenerioTable';
import { getBusinessPlanTableKpisData } from '../util2';

const BusinessPlan: React.FC<BusinessPlanProps> = ({
  selectedRegion,
  selectedRegionData,
  handleValueChangeWrapper,
  handleRevertToOriginalWrapper,
}) => {
  const tableData = getBusinessPlanTableKpisData(selectedRegionData?.categoryData);

  return (
    <div data-testid='business-plan'>
      {selectedRegionData && (
        <RowGroups
          tableData={tableData}
          selectedRegion={selectedRegion}
          onInputChange={handleValueChangeWrapper}
          onRevertToOriginal={handleRevertToOriginalWrapper}
        />
      )}
    </div>
  );
};

export default BusinessPlan;
